import React, { Component } from 'react';
import './Login.css';
import ApiService from '../modules/ApiService';
import { Button, Typography } from '@material-ui/core';

class Login extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.Auth = new ApiService();
    }
    componentWillMount() {
        if (this.Auth.loggedIn())
            this.props.history.replace('/');
    }
    render() {
        return (
            <div className="center">
                <div className="card">
                    <Typography style={{ width: "100%" }} variant="h6" color="textSecondary" component="h6">
                        {"Вход в систему"}
                    </Typography>
                    <br />
                    <form onSubmit={this.handleFormSubmit}>
                        {/* <input
                            className="form-item"
                            placeholder="Логин"
                            name="username"
                            type="text"
                            onChange={this.handleChange}
                        />
                        <input
                            className="form-item"
                            placeholder="Пароль"
                            name="password"
                            type="password"
                            onChange={this.handleChange}
                        /> */}

                        <Button variant="contained" type="submit" color="primary" style={{ marginTop: "4%", backgroundColor: "rgb(62,102,161)" }}>
                            Войти
                        </Button>

                    </form>
                </div>
            </div>
        );
    }

    async handleFormSubmit(e) {
        e.preventDefault();

        try {
            window.location.href = '/api/auth/oauth2'
        } catch (error) {
            alert(error)
        }
    }

    handleChange(e) {
        this.setState(
            {
                [e.target.name]: e.target.value
            }
        )
    }
}

export default Login;